import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// MALWEST design (b_cm6qg8te3j, advertiser -5243943702272902340).
// Real numbers from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (complete months Jan 2025 – Jul 2026; ~19-month tenure). NEW_ONLY — a single
// new-customers campaign, still RUNNING. Growing-but-early archetype: small
// budget scaling up (raised to $1,800/mo in Aug 2026), ~2.3x first-year ROAS.
// Monthly series + partial Aug 2026 live in realBrandData.ts.
export const advMalwest: FaireAdvertiserProfileEntity = {
  token: "adv_malwest",
  type: "advertiserProfile",
  archetype: "median-budget-median-results",
  displayName: "MALWEST design",
  brandToken: "b_cm6qg8te3j",
  audienceType: "NEW_ONLY",
  globalStatus: "ACTIVE",
  tenureMonths: 19,
  budget: {
    totalBudgetDollars: 1800,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-09-01",
    nextBillsAtDate: "2026-09-04",
  },
  overview: {
    numCustomersAcquired: 19,
    numReorderConversions: 0,
    numTotalConversions: 19,
    totalAdsSalesDollars: 6564,
    newCustomerAdsSalesDollars: 6564,
    reorderAdsSalesDollars: 0,
    totalAdsSpendDollars: 2934,
    newCustomerAdsSpendDollars: 2934,
    reorderAdsSpendDollars: 0,
    newCustomerBestEstimateFirstYearRoas: 2.28,
    reorderRoas: 0,
    combinedFirstYearRoas: 2.28,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 740,
      maxRecommendedBudgetDollars: 1480,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_mw_new"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-10T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
